import { render, staticRenderFns } from "./DataPrivacySettings.vue?vue&type=template&id=0c1e57b6&"
import script from "./DataPrivacySettings.vue?vue&type=script&lang=js&"
export * from "./DataPrivacySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports